export namespace EnumTypes {
    export enum Page {
        HOME = 'HOME',
        MAP = 'MAP',
        ZONES = 'ZONES',
        FLEET = 'FLEET',
        CONTRACTORS = 'CONTRACTORS',
        USERS = 'USERS',
        MESSAGES = 'MESSAGES',
        ACCOUNT = 'ACCOUNT',
        SETTINGS = 'SETTINGS',
        CARRAPORT = 'CARRAPORT',
        INSTALLATION_REPORT = 'INSTALLATION_REPORT',
        ACTIVE_TERMINALS_REPORT = 'ACTIVE_TERMINALS_REPORT',
        VEHICLES_STATE_REPORT = 'VEHICLES_STATE_REPORT',
        FLEETRAPORT = 'FLEETRAPORT',
        DRIVERRAPORT = 'DRIVERRAPORT',
        MANUAL = 'MANUAL',
        LANGUAGES = 'LANGUAGES',
        LOGIN = 'LOGIN',
        REGISTER = 'REGISTER',
        FORGOT_PASSWORD = 'FORGOT_PASSWORD',
        FORGOT_PASSWORD_CONFIRM = 'FORGOT_PASSWORD_CONFIRM',
        USERNAME = 'USERNAME',
        PASSWORD_MANAGEMENT = 'PASSWORD_MANAGEMENT',
        LOGOUT = 'LOGOUT',
        USER_MANAGEMENT = 'USER_MANAGEMENT',
        ACTIVATE_USER_ACCOUNT_COMPLETE = 'ACTIVATE_USER_ACCOUNT_COMPLETE',
        CARS_MANAGEMENT = 'CARS_MANAGEMENT',
        ALERTS = 'ALERTS',
        TERMINAL_INSTALLATION = 'TERMINAL_INSTALLATION',
        COLLISION = 'COLLISION',
        COLLISION_WITH_TOKEN = 'COLLISION_WITH_TOKEN',
        CAR_ROUTE_VIEWER = 'CAR_ROUTE_VIEWER',
        CONTRACT_MANAGEMENT = 'CONTRACT_MANAGEMENT',
        CONTRACT_EDIT_DATE = 'CONTRACT_EDIT_DATE',
    }

    export enum Languages {
        PL = 'PL',
        EN = 'EN',
        ES = 'ES',
        PT = 'PT'
    }
}



// WEBPACK FOOTER //
// ./src/Models/EnumTypes/PageEnumTypes.ts